// extracted by mini-css-extract-plugin
var _1 = "BugReportModal__backdrop--bMyJs ModalGeneral__backdrop--gxZiG";
var _2 = "BugReportModal__bg--yeD0X";
var _3 = "BugReportModal__button--hnRUH";
var _4 = "BugReportModal__buttons--fTQqt";
var _5 = "BugReportModal__checkOuter--w4oWm";
var _6 = "BugReportModal__content--SLSzk";
var _7 = "BugReportModal__details--xiJ0p BugReportModal__input--mxFAH CoreGeneral__roboto--UlmjE";
var _8 = "BugReportModal__error--rRQib CoreGeneral__roboto--UlmjE";
var _9 = "BugReportModal__header--WGDFi BugReportModal__headerBase--zO8pU fontSize__heading--TWIsi";
var _a = "BugReportModal__headerBase--zO8pU";
var _b = "BugReportModal__input--mxFAH CoreGeneral__roboto--UlmjE";
var _c = "BugReportModal__inputOuter--qZjDI";
var _d = "BugReportModal__inputWrap--pod20";
var _e = "BugReportModal__label--i_8RQ";
var _f = "BugReportModal__large--cBzuy BugReportModal__modal--W7Sbg";
var _10 = "BugReportModal__main--L56ze";
var _11 = "BugReportModal__medium--eyz8W BugReportModal__modal--W7Sbg";
var _12 = "BugReportModal__modal--W7Sbg";
var _13 = "BugReportModal__option--LL7c5 CoreGeneral__roboto--UlmjE";
var _14 = "BugReportModal__options--V45o0";
var _15 = "BugReportModal__selected--Fulu5 BugReportModal__option--LL7c5 CoreGeneral__roboto--UlmjE";
var _16 = "BugReportModal__small--CJbu7 BugReportModal__modal--W7Sbg";
var _17 = "BugReportModal__student--RPS1G";
var _18 = "BugReportModal__submitted--ZdhBC";
var _19 = "BugReportModal__subtitle--T5vi9 BugReportModal__headerBase--zO8pU";
var _1a = "BugReportModal__summary--yY741 BugReportModal__input--mxFAH CoreGeneral__roboto--UlmjE";
var _1b = "BugReportModal__text--_pdMl";
export { _1 as "backdrop", _2 as "bg", _3 as "button", _4 as "buttons", _5 as "checkOuter", _6 as "content", _7 as "details", _8 as "error", _9 as "header", _a as "headerBase", _b as "input", _c as "inputOuter", _d as "inputWrap", _e as "label", _f as "large", _10 as "main", _11 as "medium", _12 as "modal", _13 as "option", _14 as "options", _15 as "selected", _16 as "small", _17 as "student", _18 as "submitted", _19 as "subtitle", _1a as "summary", _1b as "text" }
